import { render, staticRenderFns } from "./VideoForm.vue?vue&type=template&id=1e48d78d&scoped=true"
import script from "./VideoForm.vue?vue&type=script&lang=js"
export * from "./VideoForm.vue?vue&type=script&lang=js"
import style0 from "./VideoForm.vue?vue&type=style&index=0&id=1e48d78d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e48d78d",
  null
  
)

export default component.exports